/*
  The trade drawer (sections/trade-signup.liquid in layout/theme.liquid): any link to #trade-account, or
  [data-open-trade], opens it as a side panel like the bag (assets/side-panel.js: its motion, the page's push,
  closing on its button, Escape or a click beside it, focus back to the link), and a link to #trade-account inside it
  goes to its form. Arriving at #trade-account, or back from sending the application, opens it.
*/
(() => {
  const dialog = document.getElementById('TradeDrawer');
  if (!dialog?.showModal || dialog.dataset.ready) return;
  dialog.dataset.ready = '';
  const heading = dialog.querySelector('h2');
  const open = (from) => {
    if (window.C4SidePanel)
      return window.C4SidePanel.open(dialog, { opener: from || null, focus: heading });
    if (!dialog.open) dialog.showModal();
    heading?.focus({ preventScroll: true });
  };
  const toForm = () => {
    const apply = dialog.querySelector('.trade-apply');
    apply?.scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
    apply
      ?.querySelector('input:not([type=hidden]), select, textarea')
      ?.focus({ preventScroll: true });
  };
  document.addEventListener('click', (event) => {
    /* A link in the drawer to somewhere on this page (Talk to us: #enquiry): close, then go. */
    const within = dialog.open && event.target.closest('a[href*="#"]');
    if (within && dialog.contains(within) && !within.href.includes('#trade-account')) {
      const to = new URL(within.href, location.href);
      if (to.pathname === location.pathname) dialog.close();
    }
    const link = event.target.closest('a[href*="#trade-account"], [data-open-trade]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (dialog.contains(link)) toForm();
    else open(link);
  });
  /* The application was sent from here: its thanks, in the drawer. (Any other contact form on the page also comes
     back "sent", so the thanks waits for this mark.) */
  const key = 'c4-trade-sent';
  dialog.querySelector('.trade-apply form')?.addEventListener('submit', () => {
    try {
      sessionStorage.setItem(key, '1');
    } catch (error) {}
  });
  let sent = false;
  try {
    sent = sessionStorage.getItem(key) === '1';
    sessionStorage.removeItem(key);
  } catch (error) {}
  const thanks = dialog.querySelector('[data-trade-sent]');
  if (sent && thanks) {
    thanks.hidden = false;
    dialog.querySelector('[data-trade-fields]').hidden = true;
    open();
  } else if (location.hash === '#trade-account') open();
})();
